export function updateSignalsTableData(
  state,
  updatedData = [],
  newDataToInsert = []
) {
  const oldData = state?.data?.data || [];

  const newData = [...oldData, ...newDataToInsert];

  for (let index = 0; index < updatedData.length; index++) {
    const updatedDataElement = updatedData[index];
    const targetDataIndex = newData.findIndex(
      (item) => item._id === updatedDataElement._id
    );

    if (targetDataIndex < 0) {
      continue;
    }

    newData[targetDataIndex] = {
      ...newData[targetDataIndex],
      ...updatedDataElement,
    };
  }

  const fullTableData = {
    ...state?.data,
    data: [...newData],
  };

  return fullTableData;
}

export function deleteSignalsTableData(state, signalIdsToRemove = []) {
  const oldData = state?.data?.data || [];

  let newData = [...oldData];

  newData = newData.filter((item) => !signalIdsToRemove.includes(item._id));

  const fullTableData = {
    ...state?.data,
    data: [...newData],
  };

  return fullTableData;
}
